import putItemDynamoDB from '../../api/putItemDynamoDB';
import { trainsTableName } from '../../api/apiConstants';

const putTrain = async (trainItem: any, myToken: any, myCustomId: any) => {
  const data = await putItemDynamoDB(
    trainsTableName,
    trainItem,
    myToken,
    myCustomId
  );
  if (data.err) {
    return null;
  }
  return data;
};

export default putTrain;
